import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { generateUrl } from 'data/utils';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { ExportProfessionalsDailyWorkloadExcelUseCaseInterface } from 'domain/usecases';

export class RemoteExportProfessionalsDailyWorkloadExcel
  implements ExportProfessionalsDailyWorkloadExcelUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<ExportProfessionalsDailyWorkloadExcelUseCaseInterface.Result>,
  ) {}

  async execute(
    params: ExportProfessionalsDailyWorkloadExcelUseCaseInterface.Params,
  ): Promise<ExportProfessionalsDailyWorkloadExcelUseCaseInterface.Result> {
    const requestUrl = generateUrl(this.url, { ...params });

    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: requestUrl,
      responseType: 'arraybuffer',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
